export enum StepKeys {
  LOGIN = 'login-step',
  REGISTER = 'register-step',
  PIN_CONFIRMATION = 'pin-confirmation-step',
  CLOSE = 'close',
  FORGOT_PASSWORD_CPF = 'forgot-password-cpf-step',
  FORGOT_PASSWORD = 'forgot-password-step',
  TERMS_OF_USE = 'terms-of-use-step',
  PRIVACY_POLICY = 'privacy-policy-step',
}
